
<template>

	<mymodal ref="modal" title="Настройка кодирования ценообразующего фактора" ok="Сохранить" :reset="reset" :check="check" :submit="submit" :ok_hide="!is_new" width="1000px" :style="'overflow: auto;'">

		<b-row class="mt-2">

            <b-col class="d-flex justify-content-end" style="text-align: end;"><strong>Выбор ценообразующего фактора</strong></b-col>
            <b-col>
                <v-select :options="attrs" v-model="attr" :clearable="false" required appendToBody appendToParent :disabled="!is_new" />
			</b-col>

        </b-row>
        
        <quality v-if="attr && attr.type == 'Качественный' && encoding" :raw_rules="encoding.rules"
			:attr="attr.attr"
            @set_new_rule="set_new_rule"
            v-on:set_new_rule_many="set_new_rule_many"
			:not_editable="not_editable"
        />

        <quantity ref="quantity" v-if="attr && attr.type == 'Количественный' && encoding"
            :rules="encoding.rules" :stat="encoding.stat" :null_value="encoding.null_value" @set_new_rules="set_new_rules" v-on:set_null_value="set_null_value"
			:not_editable="not_editable"
        />
        
	</mymodal>

</template>

<script>

import mymodal from '../../../widgets/modal'
import api from '../../../../api'
import attrs from '../../../../api/attrs'
import quality from './quality'
import quantity from './quantity'

export default
{
	props :
	{
		group_id : String,
		not_editable : Boolean,
	},

    components :
    {
        mymodal,
        quality,
        quantity,
    },
    
    data()
    {
        return {

            attrs : [],

            is_new : false,

			factor_id : null,
            attr : null,
            encoding : null,
            rules : null,

        }
    },

	mounted()
	{
		attrs.get(this)
		.then(
			desc =>
			{
				var _attrs = []

				desc.attrs.filter(attr => ! attr.not_real && attr.show && attr.show.cadastral_objects && attr.show.analogues && attr.type != "date" && attr.type != "time" && attr.type != "datetime").forEach(
					attr => _attrs.push({ label : attr.name, type : attr.type == "number" ? "Количественный" : "Качественный", attr : attr })
				)

				this.attrs = api.sort_objects_array_by_key(_attrs, "label")
			})
	},

    methods :
    {
        execute(item)
        {
            this.$refs.modal.execute()

            this.is_new = !item

            if (item)
            {
				this.factor_id = item.id
                this.attr = { label : item.attr_name, type : item.attr_type_2, attr : item.attr }

				if(item.attr_type_2 == "Количественный")
					api.call(this, "coding_factors", "rules_and_stat", { id : item.id },
						response =>
						{
							this.encoding = { rules : response.rules, null_value : response.null_value, stat : { min : response.min, max : response.max, average : response.average, none_count : response.none_count } }
						})
				else
					api.call(this, "coding_codes", "get_many", { query : { factor : item.id } },
						response =>
						{
							var rules = {}

							response.data.forEach(
								elem =>
								{
									rules[elem.value] = elem 

									elem.label = api.format_reference(item.attr.reference, elem.value)

									if(elem.label == null)
										elem.label = "Пусто"
								})

							this.encoding = { rules : rules }
						})
            }
			else
				this.factor_id = null
        },

        reset()
        {
            this.attr = null
            this.encoding = null
            this.is_new = false
        },

        submit()
        {
            if (this.is_new)
            {
				this.encoding = null

				if(this.attr.type == "Количественный")
					api.call(this, "coding_factors", "add_and_stat", { attr : this.attr.attr.id, group : this.group_id },
						response =>
						{
							this.factor_id = response.id
							this.encoding = { rules : [], stat : { min : response.min, max : response.max, average : response.average, none_count : response.none_count }, null_value : null }
							this.is_new = false

							this.$emit("need_refresh")
						})
				else
					api.call(this, "coding_factors", "add_and_fill", { attr : this.attr.attr.id, group : this.group_id },
						response =>
						{
							this.factor_id = response.id
							this.is_new = false

							api.call(this, "coding_codes", "get_many", { query : { factor : this.factor_id } },
								response =>
								{
									var rules = {}

									response.data.forEach(
										elem =>
										{
											var label = api.format_reference(this.attr.attr.reference, elem.value)

											if(label == null)
												label = "Пусто"

											rules[elem.value] =
											{
												id : elem.id,
												code : null,
												label : label,
												count_objects : elem.count_objects,
												count_analogues : elem.count_analogues 
											}
										})

									this.encoding = { rules : rules }

									this.$emit("need_refresh")
								})
						})
            }
			else
			{
				if(this.attr.type == 'Качественный')
					Object.values(this.encoding.rules).forEach(
						elem =>
						{
							if(elem.modified)
								api.call(this, "coding_codes", "set_field", { id : elem.id, field : "code", value : elem.code }, () => this.$emit("need_refresh"))
						})
				else
				{
					api.call(this, "coding_factors", "set_field", { id : this.factor_id, field : "rules", value : this.encoding.rules },
						() =>
						{
							if(this.encoding.null_value)
							{
								api.call(this, "coding_factors", "set_field", { id : this.factor_id, field : "null_value", value : this.encoding.null_value },
									() => this.$emit("need_refresh"))
							}
							else
								this.$emit("need_refresh")
						}
					)
				}
			}
        },

        check()
        {
            const res = !this.not_editable && (this.is_new && this.attr
                || this.encoding
                &&  (
						this.attr.type == 'Качественный'
						||
						(
							this.attr.type == 'Количественный'
							&&
							this.$refs.quantity
							&&
							this.$refs.quantity.check_last
							&& 
							( this.encoding.stat.none_count == 0 || ( this.encoding.null_value != null && this.encoding.null_value > 0 ))
						)
					)
				)
			return res
        },

		set_null_value(value)
		{
			this.encoding.null_value = value

			this.check()
		},

        set_new_rules(rules)
        {
            this.encoding.rules = rules
        },

        set_new_rule(id, value, code)
        {
            this.encoding.rules[value].code = code
            this.encoding.rules[value].modified = true
        },

        set_new_rule_many(labels, code)
        {
			code = Number(code)
			var rules = Object.values(this.encoding.rules)

			labels.forEach(
				label =>
				{
					var rule = rules.find(_rule => _rule.label == label)

					rule.code = code
					rule.modified = true
				})
        },
    }
}

</script>

